// ======================================================================
// File Name       : FormControlValidate
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { FormControl, Col } from 'react-bootstrap';
import { VALIDATE_TYPE, ERROR_TYPE } from '../constants/index';
import * as MessageTemplate from '../constants/MessageTemplate';
import MessageValidate from '../components/MessageValidate';
import * as ValidateUtils from '../utils/ValidateUtils';

const VALIDATION_STATE = {
  ERROR: 'error',
};

/**
 * FormControlValidate
 * props: recordNum (total record)
 * props: handlePageSelect (return start,end position by page selected)
 */
class FormControlValidate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorType: ERROR_TYPE.SUCCESS,
      errorVisible: false,
      errorMessage: '',
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.validation = this.validation.bind(this);
    this.value = props.value;
    this.fileSize = props.fileSize;
  }

  handleBlur(event) {
    const { notValidationBlur } = this.props;
    if (!notValidationBlur) {
      this.validation();
    }
  }

  /**
   * Message validate
   * @param {*} label
   * @param {*} msg
   */
  messageTemplate(label, msg) {
    return msg.replace('{0}', label);
  }

  /**
   * Message validate
   * @param {*} label
   * @param {*} msg
   */
  messageMaxNumberTemplate(label, maxNumber, msg) {
    msg = msg.replace('{0}', label);
    return msg.replace('{1}', maxNumber);
  }

  // #7372 START
  /**
   * Message validate
   * @param {*} minNumber
   * @param {*} maxNumber
   * @param {*} msg
   */
  messageMinMaxNumberTemplate(minNumber, maxNumber, msg) {
    msg = msg.replace('{0}', minNumber);
    return msg.replace('{1}', maxNumber);
  }
  // #7372 END

  validation() {
    const value = this.value;
    const fileSize = this.props.fileSize;
    let message = '';
    let errorType = ERROR_TYPE.SUCCESS;
    let errorVisible = false;
    const label = this.props.label;
    // #7372 START
    const minNumber = this.props.minNumber;
    // #7372 END
    const maxNumber = this.props.maxNumber;
    if (value) {
      let isValid = false;
      switch (this.props.validateType) {
        case VALIDATE_TYPE.PATTERN: {
          const { pattern } = this.props;
          isValid = pattern && new RegExp(pattern).test(value);
          !isValid && (message = this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT));
          break;
        }

        case VALIDATE_TYPE.URL: {
          isValid = ValidateUtils.validUrl(value);
          message = isValid ? MessageTemplate.MSG_URL_VALID : this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
          break;
        }
        case VALIDATE_TYPE.NUMERIC: {
          isValid = ValidateUtils.validNumFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_INVALID);
            break;
          }
          message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_VALID);
          break;
        }
        case VALIDATE_TYPE.NUMERIC_WITHOUT_ZERO: {
          isValid = ValidateUtils.validNumNonZeroFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_INVALID_WITHOUT_ZERO);
            break;
          }
          message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_VALID);
          break;
        }
        case VALIDATE_TYPE.ID: {
          isValid = ValidateUtils.validIdFormat(value);
          message = isValid
            ? this.messageTemplate(label, MessageTemplate.MSG_ID_VALID)
            : this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
          break;
        }
        case VALIDATE_TYPE.LOGIN_ID: {
          isValid = ValidateUtils.validLoginIdFormat(value);
          message = isValid
            ? this.messageTemplate(label, MessageTemplate.MSG_ID_VALID)
            : this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
          break;
        }
        // Step 7.0 #6 START
        case VALIDATE_TYPE.USER_LOGIN_ID: {
          isValid = ValidateUtils.validUserLoginIdFormat(value);
          message = isValid
            ? this.messageTemplate(label, MessageTemplate.MSG_ID_VALID)
            : this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
          break;
        }
        // Step 7.0 #6 END
        case VALIDATE_TYPE.ID_INCLUDING_HYPHEN: {
          isValid = ValidateUtils.validIdFormat2(value);
          message = isValid
            ? this.messageTemplate(label, MessageTemplate.MSG_ID_INCLUDING_HYPHEN_VALID)
            : this.messageTemplate(label, MessageTemplate.MSG_ID_INCLUDING_HYPHEN_INVALID);
          break;
        }
        case VALIDATE_TYPE.PASSWORD: {
          isValid = ValidateUtils.validPasswordFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
          }
          break;
        }
        case VALIDATE_TYPE.INVOICE_NUMBER: {
          isValid = ValidateUtils.validInvoiceNumber(value);
          message = isValid
            ? MessageTemplate.MSG_INVOICE_NUMBER_VALID
            : MessageTemplate.MSG_INVOICE_NUMBER_INVALID;
          break;
        }
        case VALIDATE_TYPE.EMAIL: {
          isValid = ValidateUtils.validEmail(value);
          message = isValid
            ? this.messageTemplate(label, MessageTemplate.MSG_EMAIL_VALID)
            : this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
          break;
        }
        case VALIDATE_TYPE.REAL_NUMBER: {
          isValid = ValidateUtils.validRealNumber(value);
          message = isValid
            ? MessageTemplate.MSG_REAL_NUMBER_VALID
            : MessageTemplate.MSG_REAL_NUMBER_INVALID;
          break;
        }
        case VALIDATE_TYPE.COURSE_BOX_ID: {
          isValid = ValidateUtils.validCouseBoxIdFormat(value);
          message = isValid
            ? MessageTemplate.MSG_COURSE_BOX_ID_VALID
            : MessageTemplate.MSG_COURSE_BOX_ID_INVALID;
          break;
        }
        case VALIDATE_TYPE.DRILL_QUESTION_SETTING: {
          isValid = ValidateUtils.validDrillQuestionSetting(value);
          message = isValid
            ? MessageTemplate.MSG_DRILL_QUESTION_SETTING_VALID
            : MessageTemplate.MSG_DRILL_QUESTION_SETTING_INVALID;
          break;
        }
        case VALIDATE_TYPE.IMG_FILE: {
          isValid = ValidateUtils.validImageFile(value);
          message =
            !isValid && this.messageTemplate(label, MessageTemplate.W_FILE_EXTENSION_INCORRECT);
          break;
        }
        case VALIDATE_TYPE.MAX_NUMBER: {
          isValid = ValidateUtils.validNumFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_INVALID);
            break;
          }
          isValid = ValidateUtils.validNumberRange(value, 0, maxNumber);
          message =
            !isValid &&
            this.messageMaxNumberTemplate(label, maxNumber, MessageTemplate.W_MAX_NUMBER);
          break;
        }
        case VALIDATE_TYPE.MIN_1_MAX_NUMBER: {
          isValid = ValidateUtils.validNumFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_INVALID);
            break;
          }
          isValid = ValidateUtils.validNumberRange(value, 1, maxNumber);
          message =
            !isValid &&
            this.messageMaxNumberTemplate(label, maxNumber, MessageTemplate.W_MAX_NUMBER);
          break;
        }
        case VALIDATE_TYPE.NUMBERIC_OVERLAP: {
          isValid = ValidateUtils.validNumFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_INVALID);
            break;
          }
          isValid = !this.props.isOverlap;
          message = !isValid && this.messageTemplate(label, MessageTemplate.MSG_OVERLAP);
          break;
        }
        case VALIDATE_TYPE.ID_CHECKOVERLAP: {
          isValid = ValidateUtils.validIdFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
            break;
          }
          isValid = !this.props.isOverlap;
          message = !isValid && this.messageTemplate(label, MessageTemplate.MSG_OVERLAP);
          break;
        }
        case VALIDATE_TYPE.VIDEO_SIZE: {
          isValid = ValidateUtils.validUploadMinSize(fileSize);
          if (!isValid) {
            message = MessageTemplate.MSG_UPLOAD_MIN_SIZE_INVALID;
            break;
          }

          isValid = ValidateUtils.validVideoUploadSize(fileSize);
          message = isValid
          ? MessageTemplate.MSG_VIDEO_UPLOAD_SIZE_VALID
          : MessageTemplate.MSG_VIDEO_UPLOAD_SIZE_INVALID;
          if (isValid) {
            const isValidType = ValidateUtils.validateVideoType(value);
            if (!isValidType) {
              isValid = isValidType;
              message = MessageTemplate.MSG_FILE_TYPE_INVALID_NOT_ACCEPT;
            }
          }
          break;
        }
        case VALIDATE_TYPE.DOCUMENT_SIZE: {
          isValid = ValidateUtils.validDocumentUploadSize(value);
          message = isValid
            ? MessageTemplate.MSG_DOCUMENT_UPLOAD_SIZE_VALID
            : MessageTemplate.MSG_DOCUMENT_UPLOAD_SIZE_INVALID;
          break;
        }
        case VALIDATE_TYPE.QUESTION_ANSWER: {
          isValid = ValidateUtils.validQuestionAnswer(value);
          message = isValid
            ? ''
            : MessageTemplate.MSG_QUESTION_ANSWER;
          break;
        }
        case VALIDATE_TYPE.MIN_ANSWER_LIST: {
          isValid = ValidateUtils.minMultiAnswer(value);
          message = isValid ? '' : MessageTemplate.MSG_MIN_ANSWER_LIST;
          break;
        }
        case VALIDATE_TYPE.QUESTION_SELECTIVE_SINGLE_ANSWER: {
          isValid = ValidateUtils.validSelectiveSingleQuestionAnswer(value);
          message = isValid
            ? ''
            : MessageTemplate.MSG_QUESTION_SELECTIVE_SINGLE_ANSWER;
          break;
        }
        case VALIDATE_TYPE.ITEM_COURSE_END: {
          isValid = ValidateUtils.validItemListForCourseEnd(value);
          message = isValid
            ? ''
            : MessageTemplate.MSG_ITEM_LIST_FOR_COURSE_END_INVALID;
          break;
        }
        case VALIDATE_TYPE.THUMBNAIL_SIZE_AND_TYPE: {
          isValid = ValidateUtils.validImageFileAndSizeCourse(value, fileSize);
          const kiloByte = 1024;
          const maxImageSize = 5 * kiloByte * kiloByte;
          if (fileSize > maxImageSize) {
            message
            = this.messageTemplate(label, MessageTemplate.MSG_THUMBNAIL_UPLOAD_SIZE_INVALID);
          } else {
            message =
            !isValid && this.messageTemplate(label, MessageTemplate.W_FILE_EXTENSION_INCORRECT);
          }
          break;
        }
        case VALIDATE_TYPE.ITEM_BOX_END: {
          isValid = ValidateUtils.validItemListForCourseEnd(value);
          message = isValid
            ? ''
            : MessageTemplate.MSG_ITEM_LIST_FOR_BOX_END_INVALID;
          break;
        }
        case VALIDATE_TYPE.CORRECT_ANSWER: {
          // Check if answer has two underscores or / , we will show error message
          isValid = ValidateUtils.validCorrectAnswers(value);
          if (isValid) {
            message = MessageTemplate.MSG_CORRECT_ANSWER_WRONG_PATTERN;
            isValid = false;
          } else {
            message = '';
            isValid = true;
          }
          break;
        }
        // #7372 START
        case VALIDATE_TYPE.MIN_MAX_NUMBER_WITHOUT_LABEL: {
          isValid = ValidateUtils.validNumFormat(value);
          if (!isValid) {
            message = this.messageTemplate(label, MessageTemplate.MSG_NUMERIC_INVALID);
            break;
          }
          isValid = ValidateUtils.validNumberRange(value, minNumber, maxNumber);
          message =
            !isValid &&
            this.messageMinMaxNumberTemplate(minNumber, maxNumber, MessageTemplate.W_MIN_MAX_NUMBER_WITHOUT_LABEL);
          break;
        }
        // #7372 END
        // Step SAML START
        case VALIDATE_TYPE.XML_SIZE_AND_TYPE: {
          isValid = ValidateUtils.validXmlFileAndSize(value, fileSize);
          const kiloByte = 1024;
          const maxImageSize = 5 * kiloByte * kiloByte;
          if (fileSize > maxImageSize) {
            message = this.messageTemplate(label, MessageTemplate.MSG_XML_UPLOAD_SIZE_INVALID);
          } else {
            message = !isValid && this.messageTemplate(label, MessageTemplate.W_FILE_EXTENSION_INCORRECT);
          }
          break;
        }
        // Step SAML END
        // sprint_20230522_tma START
        case VALIDATE_TYPE.ITEM_BOX_START: {
          isValid = ValidateUtils.validItemListForCourseEnd(value);
          message = isValid
            ? ''
            : MessageTemplate.MSG_ITEM_LIST_FOR_BOX_START_INVALID;
          break;
        }
        // sprint_20230522_tma END
        // Step 11.0.0 START
        case VALIDATE_TYPE.LOGIN_ID_SU: {
          isValid = ValidateUtils.validLoginIdSuFormat(value);
          message = isValid
            ? this.messageTemplate(label, MessageTemplate.MSG_ID_VALID)
            : this.messageTemplate(label, MessageTemplate.W_PATTERN_INCORRECT);
          break;
        }
        // Step 11.0.0 END
        default: {
          isValid = true;
          break;
        }
      }
      errorVisible = !isValid;
      errorType = isValid ? ERROR_TYPE.SUCCESS : ERROR_TYPE.ERROR;
    } else if (this.props.required) {
      errorVisible = true;
      errorType = ERROR_TYPE.EMPTY;
      message = this.messageTemplate(label, MessageTemplate.W_REQUIRED);
    } else {
      errorVisible = false;
    }

    this.setState({ errorVisible, errorType, errorMessage: message });
    return errorType === ERROR_TYPE.SUCCESS;
  }

  componentWillReceiveProps(newProps) {
    if (typeof newProps.value !== 'undefined') this.value = newProps.value;
    if (
      newProps.validateType &&
      newProps.validateType === VALIDATE_TYPE.LABEL &&
      typeof newProps.value !== 'undefined' &&
      newProps.value !== ''
    ) {
      this.validation();
    }
    if (newProps.validateType === VALIDATE_TYPE.THUMBNAIL_SIZE_AND_TYPE) {
      this.validation();
    }
  }

  /**
     * Render function of component
     */
  render() {
    if (this.props.validateType === VALIDATE_TYPE.QUESTION_ANSWER ||
        this.props.validateType === VALIDATE_TYPE.ITEM_COURSE_END ||
        this.props.validateType === VALIDATE_TYPE.ITEM_BOX_END ||
        this.props.validateType === VALIDATE_TYPE.QUESTION_SELECTIVE_SINGLE_ANSWER ||
        this.props.validateType === VALIDATE_TYPE.MIN_ANSWER_LIST ||
        this.props.validateType === VALIDATE_TYPE.ITEM_BOX_START) {
      return (
        <MessageValidate
          errorType={this.state.errorType}
          visible={this.state.errorVisible}
          errorMessage={this.state.errorMessage}
        />);
    } else {
      return (
        <div>
          {this.props.validateType === VALIDATE_TYPE.LABEL
            ? <div id="selectLabel">
              {this.props.value}
            </div>
            : <FormControl
              type={this.props.type}
              name={this.props.name}
              onChange={this.props.onChange}
              onBlur={this.handleBlur}
              maxLength={this.props.maxLength ? this.props.maxLength : 256}
              value={this.props.value}
              as={this.props.as}
              disabled={this.props.disabled}
              hidden={this.props.hidden}
              pattern={this.props.pattern}
              className={this.props.className}
              rows={this.props.rows}
              readOnly={this.props.readOnly}
            />}
          <MessageValidate
            errorType={this.state.errorType}
            visible={this.state.errorVisible}
            errorMessage={this.state.errorMessage}
          />
        </div>
      );
    }
  }
}

export default FormControlValidate;
